import { render, staticRenderFns } from "./factory_info.vue?vue&type=template&id=23ebd091&scoped=true"
import script from "./factory_info.vue?vue&type=script&lang=js"
export * from "./factory_info.vue?vue&type=script&lang=js"
import style0 from "./factory_info.vue?vue&type=style&index=0&id=23ebd091&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ebd091",
  null
  
)

export default component.exports